import React from 'react';
import { Platform } from 'react-native';

export interface GlobalStyleProps {
  css: string;
}

const GlobalStyle: React.FC<GlobalStyleProps> = ({ css }) => {
  React.useEffect(() => {
    const style = document.createElement('style');
    if (Platform.OS === 'web') {
      style.innerHTML = css;
      console.log({ style });
      document.head.append(style);
      const meta = document.createElement('meta');
      meta.setAttribute('name', 'viewport');
      meta.setAttribute('content', 'width=device-width, user-scalable=no');

      document.getElementsByTagName('head')[0].appendChild(meta);

      return () => style.remove();
    }

    return () => style.remove();
  }, [css]);
  return null;
};

export default React.memo(GlobalStyle);
